module.exports = __webpack_public_path__ + "static/img/img_verifcode.ad685389.png";